import styled from 'styled-components';
import tw from 'twin.macro';

import { ConfigUI } from '@/components/Feature';
import { FollowButton } from '@/components/SourceCards/components/FollowButton';
import { UnFollowButton } from '@/components/SourceCards/components/UnFollowButton';
import { usePublicSourceInfo } from '@/components/SourceCards/hooks/usePublicSourceInfo';
import { PrioritySelectorWithFetch } from '@/features/Connect/components/PrioritySelector/PrioritySelector';

export const PublicSourcesSecondaryTitle = ({
  sourceId,
  label,
}: PublicSourcesSecondaryTitle) => {
  const { showPriority, isLoading, isConnected } = usePublicSourceInfo({
    sourceId,
  });
  if (isLoading) return null;

  return (
    <Container>
      <ConfigUI feature='website_priority'>
        {showPriority ? (
          <PrioritySelectorWithFetch
            sourceId={sourceId}
            arrow={false}
            size='xs'
          />
        ) : null}
      </ConfigUI>
      <ConfigUI feature='website_unfollow'>
        {isConnected ? (
          <UnFollowButton sourceId={sourceId} label={label} />
        ) : (
          <FollowButton sourceId={sourceId} label={label} />
        )}
      </ConfigUI>
    </Container>
  );
};

const Container = styled.div`
  ${tw`flex flex-shrink-0 flex-row gap-x-4`}

  [data-reach-listbox-button] {
    ${tw`px-2 py-1`}
  }
`;

type PublicSourcesSecondaryTitle = {
  sourceId: string;
  label?: string;
};
